export const pathFunnel = {
  fromStep1: 'customer-detail',
  fromStep2: 'payment-method',
  toStep1: 'initial',
  toStep2: 'customer-detail',
  lastStep: 'confirmation',
}
